var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _g, _path9, _path10, _path11, _path12, _g2, _g3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIphone15ProMax(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 458,
    height: 863,
    viewBox: "0 0 458 863",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 458,
    height: 863,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M422.431 268.38H417.11C416.647 268.38 416.274 268.752 416.274 269.216V354.859C416.274 355.322 416.647 355.695 417.11 355.695H422.431C422.894 355.695 423.267 355.322 423.267 354.859V269.216C423.267 268.753 422.894 268.38 422.431 268.38Z",
    fill: "#6C635B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M422.479 268.705H417.063C416.626 268.705 416.274 269.057 416.274 269.495V354.579C416.274 355.017 416.626 355.37 417.063 355.37H422.479C422.915 355.37 423.267 355.017 423.267 354.579V269.495C423.267 269.057 422.916 268.705 422.479 268.705Z",
    fill: "url(#paint0_linear_3_53)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.89 231.406H35.5686C35.1057 231.406 34.7329 231.779 34.7329 232.242V283.168C34.7329 283.631 35.1055 284.004 35.5686 284.004H40.89C41.353 284.004 41.7258 283.631 41.7258 283.168V232.242C41.7258 231.779 41.3531 231.406 40.89 231.406Z",
    fill: "#6C635B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9373 231.731H35.5214C35.0845 231.731 34.7329 232.084 34.7329 232.522V282.888C34.7329 283.326 35.0844 283.679 35.5214 283.679H40.9373C41.3741 283.679 41.7258 283.326 41.7258 282.888V232.522C41.7258 232.084 41.3743 231.731 40.9373 231.731Z",
    fill: "url(#paint1_linear_3_53)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40.89 174.923H35.5686C35.1057 174.923 34.7329 175.296 34.7329 175.759V205.385C34.7329 205.848 35.1055 206.221 35.5686 206.221H40.89C41.353 206.221 41.7258 205.848 41.7258 205.385V175.759C41.7258 175.296 41.3531 174.923 40.89 174.923Z",
    fill: "#6C635B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9373 175.248H35.5214C35.0845 175.248 34.7329 175.601 34.7329 176.039V205.105C34.7329 205.543 35.0844 205.896 35.5214 205.896H40.9373C41.3741 205.896 41.7258 205.543 41.7258 205.105V176.039C41.7258 175.601 41.3743 175.248 40.9373 175.248Z",
    fill: "url(#paint2_linear_3_53)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M40.89 302.418H35.5686C35.1057 302.418 34.7329 302.791 34.7329 303.254V354.18C34.7329 354.643 35.1055 355.016 35.5686 355.016H40.89C41.353 355.016 41.7258 354.643 41.7258 354.18V303.254C41.7258 302.791 41.3531 302.418 40.89 302.418Z",
    fill: "#6C635B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9373 302.744H35.5214C35.0845 302.744 34.7329 303.096 34.7329 303.534V353.9C34.7329 354.338 35.0844 354.691 35.5214 354.691H40.9373C41.3741 354.691 41.7258 354.338 41.7258 353.9V303.534C41.7258 303.096 41.3743 302.744 40.9373 302.744Z",
    fill: "url(#paint3_linear_3_53)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3_53)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.8907 45.413H361.109C387.059 45.413 407.95 66.3038 407.95 92.2534V771.747C407.95 797.696 387.059 818.587 361.109 818.587H96.8907C70.9411 818.587 50.0503 797.696 50.0503 771.747V92.2534C50.0503 66.3038 70.9411 45.413 96.8907 45.413Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.109 38.413H96.8907C67.0751 38.413 43.0503 62.4378 43.0503 92.2534V771.747C43.0503 801.562 67.0751 825.587 96.8907 825.587H361.109C390.925 825.587 414.95 801.562 414.95 771.747V92.2534C414.95 62.4378 390.925 38.413 361.109 38.413Z",
    stroke: "#D1D1D1",
    strokeWidth: 14
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M265.684 53.6644H192.316C183.862 53.6644 177.009 60.5175 177.009 68.9714C177.009 77.4252 183.862 84.2784 192.316 84.2784H265.684C274.138 84.2784 280.991 77.4252 280.991 68.9714C280.991 60.5175 274.138 53.6644 265.684 53.6644Z",
    fill: "#343434"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M265.282 77.4297C269.953 77.4297 273.74 73.6428 273.74 68.9714C273.74 64.3 269.953 60.513 265.282 60.513C260.61 60.513 256.823 64.3 256.823 68.9714C256.823 73.6428 260.61 77.4297 265.282 77.4297Z",
    fill: "#0A0A0A"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M265.282 74.1886C268.163 74.1886 270.499 71.8528 270.499 68.9714C270.499 66.09 268.163 63.7542 265.282 63.7542C262.4 63.7542 260.064 66.09 260.064 68.9714C260.064 71.8528 262.4 74.1886 265.282 74.1886Z",
    fill: "#0C0E11"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M265.281 72.9465C267.477 72.9465 269.257 71.1668 269.257 68.9714C269.257 66.776 267.477 64.9963 265.281 64.9963C263.086 64.9963 261.306 66.776 261.306 68.9714C261.306 71.1668 263.086 72.9465 265.281 72.9465Z",
    fill: "#12171E"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_3_53)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M262.545 66.3119C262.074 66.3615 261.404 67.081 261.354 68.4951C261.305 69.9093 261.925 70.6784 262.272 70.6784C262.62 70.6784 264.058 68.6192 262.545 66.3119Z",
    fill: "#425A72",
    fillOpacity: 0.299338
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_3_53)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M265.93 65.8167C265.187 66.0455 265.044 67.2466 265.072 67.933C265.101 68.6193 266.073 70.421 267.246 70.0206C268.418 69.6202 268.619 68.1331 268.132 67.1322C267.646 66.1313 266.76 65.4163 265.93 65.8167Z",
    fill: "#425A72",
    fillOpacity: 0.299338
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3_53",
    x: 16.0503,
    y: 11.413,
    width: 425.899,
    height: 841.174,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3_53"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3_53",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_3_53",
    x: 261.051,
    y: 66.0118,
    width: 2.47287,
    height: 4.96658,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.150032,
    result: "effect1_foregroundBlur_3_53"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_3_53",
    x: 264.769,
    y: 65.4035,
    width: 3.91028,
    height: 4.97456,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.150032,
    result: "effect1_foregroundBlur_3_53"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3_53",
    x1: 423.267,
    y1: 268.836,
    x2: 423.267,
    y2: 355.145,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAD5C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.124105,
    stopColor: "#BCB6A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.764916,
    stopColor: "#9B9388"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.985317,
    stopColor: "#80786E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B9B3A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3_53",
    x1: 74.7567,
    y1: 231.862,
    x2: 74.7567,
    y2: 283.516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAD5C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.124105,
    stopColor: "#BCB6A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.764916,
    stopColor: "#9B9388"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.985317,
    stopColor: "#80786E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B9B3A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3_53",
    x1: 74.7567,
    y1: 175.379,
    x2: 74.7567,
    y2: 205.736,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAD5C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.124105,
    stopColor: "#BCB6A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.764916,
    stopColor: "#9B9388"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.985317,
    stopColor: "#80786E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B9B3A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3_53",
    x1: 74.7567,
    y1: 302.875,
    x2: 74.7567,
    y2: 354.528,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAD5C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.124105,
    stopColor: "#BCB6A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.764916,
    stopColor: "#9B9388"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.985317,
    stopColor: "#80786E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B9B3A5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIphone15ProMax);
export default __webpack_public_path__ + "static/media/iphone-15-pro-max.2485568264931e0dda9143a89fe83d08.svg";
export { ForwardRef as ReactComponent };